import axios from 'axios';
import { serverUrl } from 'Config';
import AuthService from '../services/AuthService';

class DataHelper {

    apiRequest(url) {
        return axios({
            method: 'GET',
            url: serverUrl + url,
            headers: { 'Authorization': 'Bearer ' + AuthService.getToken() }
        });
    }

    saveData(data, id) {
        return axios({
            method: (id ? 'PUT' : 'POST'),
            url: serverUrl + '/alert_rules/' + (id || ''),
            headers: { 'Authorization': 'Bearer ' + AuthService.getToken() },
            data: data
        });
    }

    getItemDetails(id) {
        //    url: serverUrl + '/alert_rules/' + id,
        return axios({
            method: 'GET',
            url: serverUrl + '/alert_rules/' + id,
            headers: { 'Authorization': 'Bearer ' + AuthService.getToken() }
        });
    }

    prepareNestedComboObj(obj, preferedId) {

        obj.Id = preferedId ? obj[preferedId] : (obj.Id || obj.id);
        obj.Name = obj.Name || obj.name || obj.Label;
        obj.taxonomy_id = obj.taxonomy_id || '';
        if (obj.children && obj.children.length) obj.Items = [...obj.children];
        delete obj.name;
        delete obj.id;
        delete obj.children;
        delete obj.Label;
        if (obj.Items) obj.Items.map(item => this.prepareNestedComboObj(item, preferedId));

        if (obj.Items) {
            let child_array = []
            obj.Items.map(item => {
                if (!(item.merged)){
                    child_array.push(item)
                }
            })
            obj.Items = child_array
        }
        if (!obj.Items) obj.Items = [];
        return obj;
    }

    sortComboArray(arr, keyItems = 'children', keyName = 'name') {
        arr = arr.sort((a, b) => {
            if (a[keyName] > b[keyName]) return 1;
            else if (a[keyName] < b[keyName]) return -1;
            else return 0;
        });

        for (let item of arr) {
            if (item[keyItems]) item[keyItems] = this.sortComboArray(item[keyItems], keyItems, keyName);
        }
        return arr;
    }

    prepareComboboxArray(arr, preferedId) {
        arr = this.sortComboArray(arr);

        for (let item of arr) item = this.prepareNestedComboObj(item, preferedId);
        return arr;
    }

    getDataFromApi() {

        return new Promise((resolve, reject) => {
            Promise.all([
                this.apiRequest('/document-categories/'),
                this.apiRequest('/regulator-selector/'),
                //this.apiRequest('/mapped-taxonomy/Service Lines'),
                this.apiRequest('/mapped-taxonomy/Regulatory Categories'),
                this.apiRequest('/colleagues/'),
                this.apiRequest('/users/personal-tags/')
            ]).then(resp => {
                const response = {};
                response.documentType = resp[0].data.categories;
                response.regulator = resp[1].data.regulators;
                //response.serviceLine = [this.prepareNestedComboObj(resp[2].data)];
                response.regCat = [this.prepareNestedComboObj(resp[2].data)];
                response.recipients = resp[3].data.usernames;
                response.tags = resp[4].data.tags.map(item => ({ label: item, value: item }));
    
                resolve(response);
            });
        });
    }

    getDataFromApiFull(flatten) {

        return new Promise((resolve, reject) => {
            Promise.all([
                this.apiRequest('/document-categories/'),
                this.apiRequest('/regulator-selector/'),
                this.apiRequest('/mapped-taxonomy/Service Lines?flat=' + flatten),
                this.apiRequest('/mapped-taxonomy/Regulatory Categories?flat=' + flatten),
                this.apiRequest('/colleagues/'),
                this.apiRequest('/saved-search/tags/'),
                this.apiRequest('/regulators/jurisdictions/')
            ]).then(resp => {
                const response = {};
                response.documentType = resp[0].data.categories;
                response.regulator = resp[1].data.regulators;
                response.serviceLine = flatten? resp[2].data.ServiceLines : [this.prepareNestedComboObj(resp[2].data)];
                response.regCat = [this.prepareNestedComboObj(resp[3].data)];
                response.recipients = resp[4].data.usernames;
                response.tags = resp[5].data.tags.map(item => ({ label: item, value: item }));
                response.jurisdictions = resp[6].data.countries;
                resolve(response);
            });
        });
    }
}
export default DataHelper;



// WEBPACK FOOTER //
// ./src/helpers/DataHelper.js